import { render, staticRenderFns } from "./TargetSKU.vue?vue&type=template&id=1d609dbc&scoped=true&"
import script from "./TargetSKU.vue?vue&type=script&lang=js&"
export * from "./TargetSKU.vue?vue&type=script&lang=js&"
import style0 from "./TargetSKU.vue?vue&type=style&index=0&id=1d609dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d609dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d609dbc')) {
      api.createRecord('1d609dbc', component.options)
    } else {
      api.reload('1d609dbc', component.options)
    }
    module.hot.accept("./TargetSKU.vue?vue&type=template&id=1d609dbc&scoped=true&", function () {
      api.rerender('1d609dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/expiration-campaign/components/TargetSKU.vue"
export default component.exports